import type { UrlTileModule } from '../url-tiles';
import { jobArchitectureLegacyUrlTileRewriter } from './url-tiles/legacy-rewriter';
import { JobArchitectureUrlTilesProvider } from './url-tiles/provider';
import { jobArchitectureUrlTileDefinitions } from './url-tiles/tile-definitions';

export type {
    JsaArchiveTilePayload,
    JsaChangelogTilePayload,
    JsaClusterDetailTilePayload,
    JsaCompareTilePayload,
    JsaFamilyDetailTilePayload,
    JsaPrimaryDetailTilePayload,
    JsaProfileDetailTilePayload,
} from './url-tile-payloads';
export {
    createJsaArchiveTilePayload,
    createJsaChangelogTilePayload,
    createJsaClusterDetailTilePayload,
    createJsaCompareTilePayload,
    createJsaFamilyDetailTilePayload,
    createJsaProfileDetailTilePayload,
    JSA_ARCHIVE_TILE_SLOT_KEY,
    JSA_ARCHIVE_TILE_TYPE,
    JSA_CHANGELOG_TILE_SLOT_KEY,
    JSA_CHANGELOG_TILE_TYPE,
    JSA_CLUSTER_DETAIL_TILE_TYPE,
    JSA_COMPARE_TILE_SLOT_KEY,
    JSA_COMPARE_TILE_TYPE,
    JSA_FAMILY_DETAIL_TILE_TYPE,
    JSA_PRIMARY_DETAIL_TILE_SLOT_KEY,
    JSA_PROFILE_DETAIL_TILE_TYPE,
} from './url-tile-payloads';
export { getJobArchitectureUrlTileChatContext, jobArchitectureUrlTileChatTypes } from './url-tiles/chat';
export { jobArchitectureLegacyUrlTileRewriter } from './url-tiles/legacy-rewriter';
export { JobArchitectureUrlTilesProvider } from './url-tiles/provider';
export {
    jobArchitectureUrlTileDefinitions,
    jsaArchiveUrlTileDefinition,
    jsaChangelogUrlTileDefinition,
    jsaClusterDetailUrlTileDefinition,
    jsaCompareUrlTileDefinition,
    jsaFamilyDetailUrlTileDefinition,
    jsaProfileDetailUrlTileDefinition,
} from './url-tiles/tile-definitions';

export const jobArchitectureUrlTileModule: UrlTileModule = {
    definitions: jobArchitectureUrlTileDefinitions,
    legacyRewriters: [jobArchitectureLegacyUrlTileRewriter],
    Provider: JobArchitectureUrlTilesProvider,
};
